import { render, staticRenderFns } from "./PPCForm.vue?vue&type=template&id=773942f8&scoped=true"
import script from "./PPCForm.vue?vue&type=script&lang=js"
export * from "./PPCForm.vue?vue&type=script&lang=js"
import style0 from "./PPCForm.vue?vue&type=style&index=0&id=773942f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773942f8",
  null
  
)

export default component.exports